import { DerivedStateStatus } from '../derived/derivers.js';
import { z } from '../zod.js';
import { IsoTimestamp, ReleaseId } from './common.js';
/** Health probes. No backup, export or restore probe exists (PLAN section 5 #1). */
export const HEALTH_PROBE_KEYS = ['database', 'migrations', 'pgboss', 'worker', 'disk'];
export const HealthProbeKey = z.enum(HEALTH_PROBE_KEYS);
export const HealthProbe = z.strictObject({
    key: HealthProbeKey,
    ok: z.boolean(),
    detail: z.string(),
    observedAt: IsoTimestamp,
});
/**
 * One row of `derived_state` (CS r1c, DECISIONS 89 item 20; 1.V-1 deliverable 10): a deriver's
 * version, last rebuild and verify outcome. `name` is any stored name, since a row may outlive its
 * deriver; `status` is null until `verify` first runs.
 */
export const DerivedStateV1 = z.strictObject({
    name: z.string(),
    deriverVersion: z.number().int().nonnegative(),
    status: DerivedStateStatus.nullable(),
    driftCount: z.number().int().nonnegative(),
    rebuiltAt: IsoTimestamp.nullable(),
});
export const HealthV1 = z.strictObject({
    status: z.enum(['ok', 'degraded', 'down']),
    release: ReleaseId,
    startedAt: IsoTimestamp,
    now: IsoTimestamp,
    probes: z
        .array(HealthProbe)
        .refine((probes) => new Set(probes.map((p) => p.key)).size === probes.length, {
        message: 'each probe key appears at most once',
    }),
    /**
     * Every `derived_state` row, in `DERIVER_NAMES` order with unknown names last (1.V-1); empty when
     * none exists or the read failed. A drifted row never changes `status`. Required since CS r2
     * (DECISIONS 96 item 1), once 1.V-1's deliverable 9 sent it on every answer.
     */
    derived: z.array(DerivedStateV1),
});
export const PingResponse = z.strictObject({
    jobId: z.string().min(1),
    roundTripMs: z.number().nonnegative(),
});
//# sourceMappingURL=health.js.map